<template>
  <button
    class="flex items-center justify-between p-4"
    @click="emit('onClick')"
  >
    <span class="flex items-center space-x-3">
      <slot name="icon" />
      <span class="font-medium">
        <slot name="label" />
      </span>
    </span>

    <span class="flex gap-x-2">
      <slot name="badge" />

      <!-- prettier-ignore -->
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path class="fill-text-neutral-quaternary" fill-rule="evenodd" d="M8.303 18.844a.792.792 0 0 1-.152-1.088l5.854-6-5.854-6a.792.792 0 0 1 .152-1.09.744.744 0 0 1 1.06.156l6.092 6.327c.262.36.262.854 0 1.213L9.363 18.69a.744.744 0 0 1-1.06.155Z" clip-rule="evenodd"/></svg>
    </span>
  </button>
</template>

<script setup lang="ts">
  const emit = defineEmits<{
    onClick: [];
  }>();
</script>
